import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import man from '../assests/AI.mp4';
import man1 from '../assests/data.mp4';
import man2 from '../assests/Lang.mp4';
import man3 from '../assests/editing.mp4';

export default function ServicesAndIndustries() {
  const services = [
    {
      title: "Data Collection",
      icon: "🖼️",
      video: man1,
      items: [
        { label: "Image & Video Collection", path: "/services/image-video" },
        { label: "Audio Collection", path: "/components/HeroSection" },
        { label: "Text Data Sourcing", path: "/services/text" }
      ]
    },
    {
      title: "Data Processing & Enhancement",
      icon: "🏷️",
      video: man,
      items: [
        { label: "Annotation & Labeling", path: "/services/annotation" },
        { label: "Audio & Video Tagging", path: "/services/tagging" },
        { label: "Text & Speech QA", path: "/services/qa" }
      ]
    },
    {
      title: "Language & Localization",
      icon: "🌐",
      video: man2,
      items: [
        { label: "Multilingual Transcription", path: "/services/transcription" },
        { label: "Translation & Localization", path: "/services/translation" },
        { label: "Dubbing & Voiceover", path: "/services/dubbing" }
      ]
    },
    {
      title: "Creative & Media Solutions",
      icon: "🎬",
      video: man3,
      items: [
        { label: "Video Editing", path: "/services/editing" },
        { label: "Content Creation", path: "/services/content" },
        { label: "Animation (2D & 3D)", path: "/services/animation" },
        { label: "Video Projects", path: "/services/projects" }
      ]
    }
  ];

  const industries = [
    { label: "Technology & AI", icon: "🤖", href: "/industries/technology" },
    { label: "E-commerce & Retail", icon: "🛒", href: "/industries/ecommerce" },
    { label: "Healthcare", icon: "🩺", href: "/industries/healthcare" },
    { label: "Automotive", icon: "🚗", href: "/industries/automotive" },
    { label: "Media & Entertainment", icon: "🎬", href: "/industries/media" },
  ];

  return (
    <section className="px-6 py-20 bg-gradient-to-br from-black via-gray-900 to-black text-white">
      {/* Services Section */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h2 className="text-4xl font-extrabold mb-4 tracking-tight font-orbitron">Our Services</h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto font-raleway">
          From multilingual data collection to creative media solutions, we power AI with precision and cultural depth.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto mb-24">
        {services.map(({ title, icon, items, video }, index) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="relative overflow-hidden rounded-2xl shadow-lg border border-gray-700 p-8 bg-black group"
            whileHover={{ scale: 1.02 }}
          >
            {/* Background Video */}
            <video
              autoPlay
              muted
              loop
              playsInline
              className="absolute inset-0 w-full h-full object-cover opacity-30"
              src={video}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 rounded-2xl pointer-events-none" />

            <div className="relative z-10 text-center">
              <motion.div
                className="text-6xl mb-6"
                animate={{ scale: [1, 1.15, 1], rotate: [0, 10, -10, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              >
                {icon}
              </motion.div>
              <h3 className="text-2xl font-semibold font-orbitron mb-4">{title}</h3>
              <div className="flex flex-wrap justify-center gap-4">
                {items.map(({ label, path }, i) => (
                  <Link
                    key={i}
                    to={path}
                    className="flex-1 min-w-[140px] sm:min-w-[180px] px-5 py-2 text-sm bg-gray-800 bg-opacity-70 text-white font-medium rounded-full border border-indigo-500 hover:bg-indigo-600 transition text-center"
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Industries Section */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h2 className="text-4xl font-extrabold tracking-tight font-orbitron">Industries We Serve</h2>
        <p className="text-lg text-gray-300 mt-4">
          Our expertise spans sectors where AI innovation and cultural understanding intersect.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {industries.map(({ label, icon, href }, index) => (
          <Link key={index} to={href}>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className="bg-gray-800 rounded-2xl shadow-md p-8 text-center transition border border-gray-700 hover:shadow-xl"
            >
              <motion.div
                className="text-4xl mb-4"
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ repeat: Infinity, duration: 2.5, delay: index * 0.2 }}
              >
                {icon}
              </motion.div>
              <p className="text-lg font-semibold">{label}</p>
            </motion.div>
          </Link>
        ))}
      </div>
    </section>
  );
}
